export default function sumByKey(data, key) {
  return data.reduce((total, obj) => total + (parseInt(obj[key]) || 0), 0);
}
